export { isPrintAllowed } from './utils/isPrintAllowed';
export { isDownloadAllowed } from './utils/isDownloadAllowed';
export { downloadAttachmentFromUrl } from './utils/downloadAttachmentFromUrl';
export { openInNewTab } from './utils/openInNewTab';

import { LazyAction, LazyModule } from 'owa-bundling';

const lazyModule = new LazyModule(() =>
    import(/* webpackChunkName: "AttachmentOps" */ './lazyIndex')
);

export const lazyPrint = new LazyAction(lazyModule, m => m.print);
export const lazyDownload = new LazyAction(lazyModule, m => m.download);
